<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-brush`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 16v4a2 2 0 01-2 2H7a2 2 0 01-2-2V8a2 2 0 012-2h26a2 2 0 012 2v4h7a1 1 0 011 1v15.122a1 1 0 01-.87.992L20 32v10a1 1 0 01-1 1h-2a1 1 0 01-1-1V29.554a1 1 0 01.87-.992L39 25.676V16h-4zM9 10v8h22v-8H9z"/></svg>
</template>
<script>

export default {
  name: 'IconBrush',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
